import type { ReactNode } from 'react';
import { ArchiveIcon, BellIcon, ChatIcon, WrenchIcon, ContractorsIcon, HomeIcon, JobsIcon, MoreIcon, RequestsIcon, SettingsIcon } from '../icons';

export interface NavItem {
  to: string;
  label: string;
  icon: ReactNode;
  /** מפתח לתג מונה (למשל בקשות ממתינות) */
  badge?: 'pendingRequests' | 'unreadNotifications' | 'unreadMessages';
  end?: boolean;
  /** מוצג רק למפתח */
  ownerOnly?: boolean;
}

export const PRIMARY_NAV: NavItem[] = [
  { to: '/', label: 'בית', icon: <HomeIcon />, end: true },
  { to: '/jobs', label: 'עבודות', icon: <JobsIcon /> },
  { to: '/requests', label: 'בקשות', icon: <RequestsIcon />, badge: 'pendingRequests' },
  { to: '/contractors', label: 'קבלנים', icon: <ContractorsIcon /> },
];

export const SECONDARY_NAV: NavItem[] = [
  { to: '/messages', label: 'הודעות', icon: <ChatIcon />, badge: 'unreadMessages' },
  { to: '/notifications', label: 'התראות', icon: <BellIcon />, badge: 'unreadNotifications' },
  { to: '/archive', label: 'ארכיון', icon: <ArchiveIcon /> },
  { to: '/settings', label: 'הגדרות', icon: <SettingsIcon /> },
  { to: '/dev', label: 'מסך מפתח', icon: <WrenchIcon />, ownerOnly: true },
];

/** פריטי הניווט המשני שהמשתמש רשאי לראות */
export function secondaryNavFor(role: 'owner' | 'admin'): NavItem[] {
  return SECONDARY_NAV.filter((i) => !i.ownerOnly || role === 'owner');
}

export const MOBILE_MORE: NavItem = { to: '/more', label: 'עוד', icon: <MoreIcon />, badge: 'unreadNotifications' };
